import { render, staticRenderFns } from "./RadarSection.vue?vue&type=template&id=3fdaa0bf&scoped=true&"
import script from "./RadarSection.vue?vue&type=script&lang=js&"
export * from "./RadarSection.vue?vue&type=script&lang=js&"
import style0 from "./RadarSection.vue?vue&type=style&index=0&id=3fdaa0bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaa0bf",
  null
  
)

export default component.exports